import {ArrowNarrowLeftIcon} from '@heroicons/react/outline';
import {useNavigate, useParams} from 'react-router-dom';

import {Header} from '@/components';

import BusinessRFINotesTable from './BusinessRFINotesTable';
import {useBusinessRFILog} from './useBusinessRFILog';

const BusinessRFILogsScreen = () => {
  const {rfiId} = useParams();
  const navigate = useNavigate();
  const {rfi, isLoading, resolveActor, forLabel} = useBusinessRFILog(rfiId);

  const renderLogs = () => {
    if (isLoading) {
      return (
        <div className="mt-6">
          <BusinessRFINotesTable isLoading />
        </div>
      );
    }

    if (!rfi) {
      return (
        <p className="text-sm text-gray-500 dark:text-gray-400 py-10 text-center">
          RFI not found.
        </p>
      );
    }

    return (
      <div className="mt-6">
        <div className="mb-2 flex flex-wrap gap-x-8 gap-y-1">
          <p className="text-sm text-gray-500 dark:text-gray-300">
            RFI ID:{' '}
            <span className="font-medium text-gray-800 dark:text-gray-100">
              {rfi.id}
            </span>
          </p>
          <p className="text-sm text-gray-500 dark:text-gray-300">
            For:{' '}
            <span className="font-medium text-gray-800 dark:text-gray-100">
              {forLabel}
            </span>
          </p>
        </div>
        <BusinessRFINotesTable
          isLoading={false}
          notes={rfi.notes}
          resolveActor={resolveActor}
        />
      </div>
    );
  };

  return (
    <main className="mt-10 mb-5 mx-4 md:mx-10">
      <div className="flex items-center gap-3">
        <Header
          title=""
          icon={
            <div
              className="flex text-blue-500 cursor-pointer"
              onClick={() => navigate(-1)}
            >
              <ArrowNarrowLeftIcon className="font-light w-5 h-5 dark:text-white hover:text-indigo-500 dark:hover:text-indigo-500 mr-3" />
              <span className="font-medium">Back</span>
            </div>
          }
        />
      </div>

      {renderLogs()}
    </main>
  );
};

export default BusinessRFILogsScreen;
